import { useCallback, useRef } from 'react'

/** The admin list/detail grids become two panes at Tailwind's `lg`; below it they stack. */
const STACKED_LAYOUT_QUERY = '(max-width: 1023px)'

/**
 * While the list and its detail pane are stacked (phone, small tablet) the detail can sit below
 * the fold, so picking a row looks like nothing happened. `reveal()` scrolls the detail into
 * view after a selection; it does nothing in the two-pane desktop layout.
 */
export function useRevealDetail<T extends HTMLElement = HTMLDivElement>() {
  const ref = useRef<T>(null)
  const reveal = useCallback(() => {
    if (!window.matchMedia(STACKED_LAYOUT_QUERY).matches) return
    requestAnimationFrame(() =>
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    )
  }, [])
  return { ref, reveal }
}
